export const customStyles = {
    control: base => ({
        ...base,
        color : "#2a63ad"
        
    }),
    container: base => ({
        ...base,
        color : "#2a63ad",
       
       
    }),
    dropdownIndicator: base => ({
        ...base,
        padding: 4
    }),
    clearIndicator: base => ({
        ...base,
        padding: 4
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px 6px',
        color : "#2a63ad"
    }),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0,
        color : "#2a63ad"
    }),
    
};